import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Optional } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckoutVaultCardComponentDef } from '@df/checkout/checkout-vault-card.component.def';
import { InputWrapBodyDirective } from '../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../ui/form/input-wrap.component';
import { CheckoutFormComponent } from './../form/checkout-form.component';
import { CheckoutStepComponent } from './../step/checkout-step.component';
@Component({
    selector: 'checkout-vault-card',
    templateUrl: './checkout-vault-card.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [FormsModule, InputWrapComponent, CommonModule, InputWrapBodyDirective]
})
export class CheckoutVaultCardComponent extends CheckoutVaultCardComponentDef {
    constructor(checkoutFormComponent: CheckoutFormComponent, _ref: ChangeDetectorRef, @Optional() protected override checkoutStepcomponent?: CheckoutStepComponent) {
        super(checkoutFormComponent,  _ref, checkoutStepcomponent);
    }
}
